module.exports = __webpack_public_path__ + "static/event_5-d0b2000898e41de8f8fbbed80f4cc9c7.png";